export enum ChargesModes {
    Add = 'Add',
    Edit = 'Edit',
    View = 'View',
  }
  